import imageCompression from 'browser-image-compression';

/**
 * 压缩图片
 * @param file 原始图片文件
 * @param maxSizeMB 压缩阈值（MB），如果文件小于此值，返回原文件
 * @returns 压缩后的文件，如果文件小于阈值或压缩失败，返回原文件
 */
export async function compressImage(
  file: File,
  maxSizeMB: number
): Promise<File> {
  // 检查文件大小是否超过阈值
  const fileSizeMB = file.size / (1024 * 1024);
  if (fileSizeMB <= maxSizeMB) {
    // 文件小于阈值，不需要压缩
    return file;
  }

  // 检查是否为支持的图片格式
  const supportedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'];
  if (!supportedTypes.includes(file.type)) {
    // 不支持的格式，返回原文件
    console.warn(`不支持的图片格式: ${file.type}，跳过压缩`);
    return file;
  }

  try {
    // 压缩选项
    const options = {
      maxSizeMB: maxSizeMB, // 目标文件大小（MB）
      maxWidthOrHeight: 1920, // 最大宽度或高度
      useWebWorker: true, // 使用Web Worker提高性能
      fileType: file.type, // 保持原格式
      initialQuality: 0.8, // 初始压缩质量（0-1）
      alwaysKeepResolution: false, // 允许调整分辨率
    };

    // 执行压缩
    const compressedFile = await imageCompression(file, options);
    
    // 检查压缩后的文件大小
    const compressedSizeMB = compressedFile.size / (1024 * 1024);
    console.log(
      `图片压缩完成: ${file.name}, 原始大小: ${fileSizeMB.toFixed(2)}MB, 压缩后: ${compressedSizeMB.toFixed(2)}MB`
    );

    return compressedFile;
  } catch (error) {
    // 压缩失败，返回原文件
    console.error('图片压缩失败:', error);
    return file;
  }
}

/**
 * 检查文件是否为图片格式
 * @param file 文件对象
 * @returns 是否为图片
 */
export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}
